import { PrivilegeDto, UserDto } from '../../shared/types/api'

let PrivilegesUtil = {
    hasPrivilege: function(user: UserDto, privilege: PrivilegeDto) {
        return user != null && user.privileges != null && user.privileges.some((item) => item.name === privilege.name)
    }
}

export default PrivilegesUtil
